import React from "react"
import { ContentWrapper } from "./style"

import { parseBlockContent } from "../../utils/customBlocks"

const Content = ({ content, blog }) => {

  return (
    <ContentWrapper blog={blog}>{parseBlockContent(content || "")}</ContentWrapper>
  )
}

export default Content
